<template>
    <div class="page1">

        <!-- <Header/> -->
        <div class="pb-4">

            <div class="page-header d-none d-md-block">
                <div class="container">
                    <div class="page-header__logo text-start pt-4 pb-3">
                        <img src="./assets/4-01.png" alt="">
                    </div>
                    <div class="page-headline text-center">
                        <img src="./assets/3-01.png" alt="">
                    </div>
                </div>
            </div>
            <div class="page-header d-block d-md-none">
                    <div class="container">
                        <!-- <div class="page-header__logo_mb text-start">
                            <img src="./assets/4-01.png" alt="">
                        </div> -->
                        <div class="page-headline_mb text-center">
                            <img src="./assets/3-01_mb.png" alt="">
                            
                        </div>
                    </div>
                </div>

            <div class="position-relative">
                
                <ContactForm
                v-model="form"
                :step="form.step"
                @change-step="ChangeStep"
                />

                <!-- error message -->
                <div v-if="error.msg">
                    <div class="container">
                        <div class="text-center">
                            <p class="text-danger h4 bold">{{ error.msg }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- error message end -->

            <div class="page-footer">
                <div class="footer__pc">
                    <div class="page-left d-none d-lg-block">
                        <img src="./assets/2-01.png" alt="">
                    </div>
                    <div class="page-right d-none d-lg-block">
                        <img src="./assets/1-01.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>

import ContactForm from '@/components/ContactFormSummer.vue'

// mixins import
import Page1 from '@/plugins/TestPlugin/mixins/page1'

export default {
    mixins: [Page1],
    created() {
    },
    components: {
        ContactForm
    },
    data() {
        return {
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    beforeUpdate() {
    },
    destroyed() {
    },
    updated() {
    }

}
</script>


<style lang="scss">

input:-webkit-autofill,
input:-webkit-autofill:focus {
    background-image: url(./assets/input-pg.svg) !important;
    background-color: unset;
}

#placement-test-newyear-layout {

    .btn-next {
        background-image: url(./assets/btn-next-pg.png);
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        color: transparent;
        width: 140px;
        height: 55px;
    }

    .page1 {
        .btn-custom.btn-success {
            background-color: transparent;
            box-shadow: none;
            border: 0;
        }
    }
    
    .form-info.xmas .form-group > div {
        
        position: relative;

        input {
            background-image: url(./assets/input-pg.svg);
            background-repeat: repeat-x;
            background-size: contain;
            border-radius: 0;
        }

        &::before {
            content: '';
            display: block;
            width: 30px;
            height: 76px;
            background-image: url(./assets/input-left.png);
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            top: -14px;
            left: -26px;
            z-index: 1000;
        }

        &::after {
            content: '';
            display: block;
            width: 30px;
            height: 76px;
            background-image: url(./assets/input-right.png);
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            top: -14px;
            right: -26px;
            z-index: 1000;
        }
    }
}

</style>

<style lang="scss" scoped>

$sc1000: 1000px;

@mixin sc1000 {
    @media (max-width: #{$sc1000}) {
        @content;
    }
}

@mixin sc1280 {
    @media (max-width: #{1280px}) {
        @content;
    }
}
@mixin sc1024 {
    @media (max-width: #{1024px}) {
        @content;
    }
}
@mixin sc1376 {
    @media (max-width: #{1376px}) {
        @content;
    }
}
@mixin sc1680 {
    @media (max-width: #{1680px}) {
        @content;
    }
}
@mixin sc360 {
    @media (max-width: #{360px}) {
        @content;
    }
}
@mixin sc390 {
    @media (max-width: #{390px}) {
        @content;
    }
}
@mixin sc390 {
    @media (max-width: #{390px}) {
        @content;
    }
}
.page1 {

    .page-headline {
        height: 400px;
        margin: auto;
        position: relative;
        width: fit-content;
        top:-75px;
        @include sc1000 {
            margin-top: 10px;
        }

        img {
            position: relative;
            display: block;
            max-width: 800px;
        }
    }

}



.page1 {
    background-image: url(./assets/bg-01.jpg);
    min-height: 100vh !important;
    background-size: cover;
    background-position: bottom center;
    min-height: 100vh !important;
    // background-attachment: fixed;

}

.page-header {
    position: relative;

    .page-header{
        &__logo {
        
            @include sc1000 {
                text-align: center !important;
            }
            img {
                max-width: 230px;
            }
        }
        &__logo_mb {
            position: relative;
            top: 40px;
            text-align: center !important;
            img {
                max-width: 150px;
            }
        }
    }
}

.page-footer {

    .footer__pc{
        position: absolute;
        width: 100%;
        bottom: 0;
        height: 250px;
        z-index: 1;
        .page-left{
            img{
                position: absolute;
                left: 300px;
                width: 363px;
                top: -276px;
                @include sc1680 {
                    left: 195px;
                    width: 360px;
                    top: -284px;
                }
                @include sc1376 {
                    left: 92px;
                    width: 290px;
                    top: -204px;
                }
                @include sc1280 {
                    left: 29px;
                    width: 288px;
                    top: -202px;
                }
                @include sc1024 {
                    left: -72px;
                }
            }
        }
        .page-right{
            img{
                position: absolute;
                right: 327px;
                width: 298px;
                top: -233px;
                @include sc1680 {
                    right: 200px;
                    width: 298px;
                    top: -229px;
                }
                @include sc1376 {
                    right: 194px;
                    width: 245px;
                    top: -173px;
                }
                @include sc1280 {
                    right: 138px;
                    width: 245px;
                    top: -173px;
                }
                @include sc1024 {
                    right: 14px
                }
            }
        }
    }
}

.page-middle {

    margin-top: 25px;
    
    
}

.invalid-feedback {
    color: #ffc0c6;
}

.form-info {

    position: relative;

    @include sc1000 {
        padding-left: 20px;
        padding-right: 20px;
    }
    
    .lan-1 {
        position: absolute;
        left: -115%;
        bottom: -30px;
        
        @include sc1000 {
            display: none;
        }
    }

    .lan-2 {
        position: absolute;
        right: -115%;
        bottom: -30px;

        @include sc1000 {
            display: none;
        }
    }


    .form-group {

        margin-bottom: 20px;
        margin-top: 36px;

        div {

            input {
                border: none;
                margin: 0;
                box-shadow: none;
                z-index: 999;
                position: relative;
                background-color: transparent;               
            }
        }
    }

}

.title-form {
    
    h5{
        text-align: center;
        color: #fff;
        font-weight: 500;
        font-size: 1.3rem;
    }
}


</style>

<style scoped>

.form-info{
    width: 45%;
    max-width: 450px;
    margin: auto;
}
.form-control {
    border-radius: 15px;
    color: #0158a8;
    line-height: 1.5;
    margin-bottom: 20px;
    font-weight: 600;
    box-shadow: 0px 4px 3px #1b96f2;
    height: 50px;
    padding: 15px;
}
.form-control::-webkit-input-placeholder {
    color: #0158a8;
}
.input-group-5{
    display: flex;
    align-items: center;
    border-radius: 15px;
    color: #0158a8;
    margin-bottom: 18px;
    font-weight: 600;
    box-shadow: 0px 4px 3px #1b96f2;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;height: 50px;
    padding: 15px;
    appearance: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-control-input {
    top: 10px;
}
.checkbox {
    display:flex;
    flex-direction:column;
    align-items: center;
    margin-left: 40px;
}

@media only screen and (max-width: 1200px){
    .form-info {
        width: 50%;
    }
}

@media only screen and (max-width: 992px){
    .form-info {
        width: 65%;
    }
}

@media only screen and (max-width: 768px){

    .form-info {
        width: 100%;
    }
    .learn-check {
        margin: 0 0px 0 10px;
    }
    .checkbox{
        margin-left: 10px;
    }
    .title-form h5 {
        font-size: 18px;
    }
    .input-group-5{
        height: auto;
        display: block;
        text-align: center;
        box-shadow: 0px 5px 10px #bac1c5;
        z-index: 9;
        position: relative;
    }
    .learn-check {
        padding-left: 0px;
        display: block;
        margin-bottom: 20px;
    }
    .input-group-5 .checkbox{
        display: inline-block !important;
    }
    .input-group-5 .checkbox:last-child{
        margin-left: 30px;
    }
    .cloudy-pg1{
        bottom: -160px;
    }
    .btn-custom.btn-success{
        font-size: 25px;
    }
}
@media only screen and (min-width: 1024px)  and (max-width: 1400px){
    .cloudy-pg1{
        bottom: -220px;
    }
}


@media (max-width: 680px){
    form.qanda {
        width: unset;
    }

    form.qanda .custom-radio {
        margin-top: 10px;
    }
}

</style>